"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateSummary = void 0;
const react_1 = __importDefault(require("react"));
const RateCards_1 = __importDefault(require("./components/RateCard/RateCards"));
const CardsContext_1 = __importDefault(require("./context/CardsContext"));
const RateSummary_1 = __importDefault(require("./components/RateSummary/RateSummary"));
exports.RateSummary = RateSummary_1.default;
const ZHLRateCards = (props) => (react_1.default.createElement(CardsContext_1.default.Provider, { value: props },
    react_1.default.createElement(RateCards_1.default, null)));
exports.default = ZHLRateCards;
